/**
 * Created by Ning Jiang on 10/24/2018.
 */

import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export class HarlequinReelSymbolStateCreator extends ReelSymbolStateCreator {

    constructor() {
        super();
    }

    protected noWinStateCreator(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const stateAnimation:TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if(stateAnimation) {
            stateAnimation.tint = 0x555555;
        }
        return stateAnimation;
    }


    protected getBasicStateAnimation(symbol: StateReelSymbol, stateKey: string, stateConfig: ISymbolStateConfig): TimelineSprite | null {
        if(symbol.symName.indexOf("W") > -1) {
            /*
              const sprite:PIXI.Sprite = new PIXI.Sprite();
              sprite.width = 100;
              sprite.height = 190;
             */
            return null;
        }
        else {
            return super.getBasicStateAnimation(symbol, stateKey, stateConfig);
        }
    }
}